/**
 * 应用配置文件
 *
 * 数据源配置
 *
 * USE_SERVER_DATA:
 *   - true: 严格服务器模式 - 只从Django服务器获取数据 (需要启动后端服务)
 *           注意：服务器失败时会直接报错，不会降级到本地数据
 *   - false: 本地文件模式 - 从本地JSON文件获取数据 (src/data/config.json, src/data/yogaData.json)
 */

export const DATA_SOURCE_CONFIG = {
  USE_SERVER_DATA: true,  // 👈 修改这里切换数据源

  // 服务器配置 (仅在 USE_SERVER_DATA = true 时生效)
  // 优先使用环境变量 REACT_APP_API_URL，否则使用默认值
  // 生产环境使用空字符串（相对路径），开发环境使用 localhost:8100
  // 在构建时设置 REACT_APP_API_URL 环境变量来覆盖默认值
  SERVER_URL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8100'),
  API_BASE_PATH: '/api/yoga',
};

/**
 * 其他应用配置
 */
export const APP_CONFIG = {
  // 应用名称
  APP_NAME: 'YogaFlow',

  // 版本信息
  VERSION: '1.0.0',

  // 默认用户名（用于演示）
  DEFAULT_USER: '瑜伽爱好者',

  // 缓存配置
  CACHE_DURATION: 5 * 60 * 1000, // 5分钟

  // 分页配置
  PAGE_SIZE: 10,

  // 主题配置
  THEME: {
    PRIMARY_COLOR: '#10b981', // emerald-500
    SECONDARY_COLOR: '#059669', // emerald-600
    ACCENT_COLOR: '#0d9488', // teal-600
  }
};

/**
 * API端点配置
 */
export const API_ENDPOINTS = {
  // 基础数据
  POSES: '/poses/',
  TEACHERS: '/teachers/',
  PHILOSOPHIES: '/philosophies/',
  EXERCISES: '/exercises/',

  // 社区数据
  STORIES: '/stories/',
  INSIGHTS: '/insights/',
  REFLECTIONS: '/reflections/',
  PHILOSOPHY_REFLECTIONS: '/philosophy-reflections/',

  // 用户认证
  AUTH: {
    LOGIN: '/auth/login/',
    SMS_LOGIN: '/auth/sms-login/',
    REGISTER: '/auth/register/',
    SEND_SMS_CODE: '/auth/send-sms-code/',
    WECHAT_CONFIG: '/auth/wechat/config/',
    WECHAT_LOGIN: '/auth/wechat/login/',
    LOGOUT: '/auth/logout/',
    PROFILE: '/auth/profile/',
  },

  // 用户私人数据（我的帖子）
  MY_POSTS: {
    REFLECTIONS: '/reflections/my_reflections/',
    STORIES: '/stories/my_stories/',
    INSIGHTS: '/insights/my_insights/',
  },

  // 仪表板
  DASHBOARD: {
    STATS: '/dashboard/stats/',
  }
};

export default {
  DATA_SOURCE_CONFIG,
  APP_CONFIG,
  API_ENDPOINTS,
};
